// extracted by mini-css-extract-plugin
module.exports = {"paper":"style_paper__3J9WQVaKzxqtPqF3d2oek4"};